/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'privacyPage',
	title: 'Privacy Policy Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'header',
			title: 'Header Section',
			type: 'object',
			fields: [
				{
					name: 'title',
					title: 'Header Title',
					type: 'string',
					validation: (Rule: any) => Rule.required(),
					initialValue: 'Privacy Policy',
				},
				{
					name: 'subtitle',
					title: 'Header Subtitle',
					type: 'text',
					initialValue:
						'How we collect, use, and protect your personal information',
				},
				{
					name: 'backgroundImage',
					title: 'Background Image',
					type: 'image',
					options: {
						hotspot: true,
					},
				},
				{
					name: 'overlayOpacity',
					title: 'Background Overlay Opacity',
					description: 'Value between 0 (transparent) and 100 (opaque)',
					type: 'number',
					validation: (Rule: any) => Rule.min(0).max(100),
					initialValue: 50,
				},
			],
		},
		{
			name: 'introduction',
			title: 'Introduction Text',
			type: 'text',
			description: 'Brief introduction to the privacy policy',
			initialValue:
				'Last Updated: April 2024. This privacy policy describes how we collect, use, and handle your personal information when you use our website and services.',
		},
		{
			name: 'lastUpdated',
			title: 'Last Updated Date',
			type: 'date',
			description: 'When was the privacy policy last updated',
			options: {
				dateFormat: 'MMMM YYYY',
			},
		},
		{
			name: 'policies',
			title: 'Privacy Policies',
			type: 'array',
			of: [
				{
					type: 'object',
					name: 'policy',
					fields: [
						{
							name: 'title',
							title: 'Title',
							type: 'string',
							validation: (Rule: any) => Rule.required(),
						},
						{
							name: 'content',
							title: 'Content',
							type: 'array',
							of: [{ type: 'block' }],
							validation: (Rule: any) => Rule.required(),
						},
					],
				},
			],
		},
		{
			name: 'footer',
			title: 'Footer Note',
			type: 'text',
			initialValue:
				'By using our website and services, you consent to the privacy practices described in this policy.',
		},
		{
			name: 'seo',
			title: 'SEO Settings',
			type: 'object',
			fields: [
				{
					name: 'metaTitle',
					title: 'Meta Title',
					type: 'string',
				},
				{
					name: 'metaDescription',
					title: 'Meta Description',
					type: 'text',
				},
			],
		},
	],
	preview: {
		select: {
			title: 'title',
			lastUpdated: 'lastUpdated',
		},
		prepare({ title, lastUpdated }: any) {
			return {
				title,
				subtitle: lastUpdated ? `Last updated: ${lastUpdated}` : '',
			};
		},
	},
};
